import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Head from "./chat/Head";
import Messages from "./chat/Messages";
import SendMessage from "./chat/SendMessage";
import { getCampaignById, getInfluencerByCampaignId } from "../../api/campaigns";

const CampaignInfluencer = () => {
  const { influencerId, id } = useParams();
  const [lookalike, setLookalike] = useState(null);
  const [campaignInfluencer, setCampaignInfluencer] = useState(null);
  const [campaign, setCampaign] = useState(null);
  // const [channel, setChannel] = useState(null);
  const [messages, setMessages] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [conversation, setConversation] = useState({});
  const [followUp, setFollowUp] = useState(null);

  const fetchInfluencer = useCallback(async () => {
    try {
      const response = await getInfluencerByCampaignId(influencerId);

      setLookalike(response.influencer);
      setCampaignInfluencer(response.campaignInfluencer);
      setMessages(response.conversation?.messages || []);
      setConversationId(response.conversation?._id);
      setConversation(response.conversation);
      setFollowUp(response.followUp);
    } catch (error) {
      console.error(error);
      toast.error('Error fetching influencer');
    }
  }, [influencerId]);

  useEffect(() => {
    if (influencerId) {
      fetchInfluencer();
    }
  }, [fetchInfluencer, influencerId]);

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const response = await getCampaignById(id);

        setCampaign(response);
      } catch (error) {
        console.error(error);
        toast.error('Error fetching campaign');
      }
    }

    if (id) {
      fetchCampaign();
    }
  }, [id]);

  if (!lookalike || !campaign) return null;

  return (
    <div className="relative h-[calc(100vh-4rem)] w-full">
      <Head
        lookalike={lookalike}
        campaignInfluencer={campaignInfluencer}
        campaign={campaign}
        // channel={channel}
        conversation={conversation}
        followUp={followUp}
      />
      <Messages
        messages={messages}
        conversationId={conversationId}
        lookalike={lookalike}
        fetchInfluencer={fetchInfluencer}
        campaign={campaign}
      />
      <SendMessage
        conversationId={conversationId}
        fetchInfluencer={fetchInfluencer}
      />
    </div>
  );
}

export default CampaignInfluencer;